
const NotFound = () => {
  return (
    <div>
      <h1>Pagina no encontrada</h1>
    </div>
  );
};

export default NotFound;